module.exports = __webpack_public_path__ + "static/img/updatePopBg.78c16f2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/updatePopBg.webp
// module id = znGn
// module chunks = 0